import Button from "@/components/library/Buttons/Button";
import { ButtonType } from "@/types/library/Buttons";
import {
  type IActionsViewModel,
  LoginSection,
} from "@/components/screens/login/types/login";

const LoginActions = ({ vm }: { vm: IActionsViewModel }) => (
  <>
    <div className="flex items-center justify-end">
      {vm.currentSection === LoginSection.ForgotPassword && (
        <Button
          buttonType={ButtonType.Secondary}
          text="Back"
          id="back-button"
          width=""
          onClick={vm.onBackButtonHandler}
        />
      )}
      <Button
        buttonType={ButtonType.Primary}
        isSubmitButton
        id="login-button"
        text={vm.labels.loginButtonTitle}
        width=""
        onClick={vm.loginButtonOnClick}
      />
    </div>
  </>
);

export default LoginActions;
